import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class ListosParaBruto {
  static getById (id) {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_cea_lista_para_bruto?r=` +
      `{"clave": {"numero": "${id}"}}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => result.data[0])
  }

  static getTodos () {
    const axios = getAxiosInstance()
    const orden = '{"orden":["fecha_de_egreso_calado"]}'
    const promise = axios.get(`consulta_cea_lista_para_bruto_listado?r=${orden}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }
}

export default ListosParaBruto
